export default __webpack_public_path__ + "static/media/nodata.aba6a096.svg";